angular.module('leanlaw').filter('sumOfValue', () => function (data, key, filter, filterKey) {
  if (typeof data === 'undefined' && typeof key === 'undefined') {
    return 0;
  }
  let sum = 0;
  for (let i = 0; i < data.length; i++) {
    if (data[i][filterKey] === filter) sum += data[i][key];
  }
  return Math.round(sum * 100) / 100;
}).filter('sum', [function () {
  return function (items, prop) {
    const start = {};
    if (prop) start[prop];
    return _.reduce(items, (sum, item) => sum + ((prop ? item[prop] : item) || 0), 0);
  };
}]);